import { useEffect } from 'react';
import { isChildMode } from './useChildListener';

// Set while the page stands on a route its URL does not show.
let pageRoute: string | null = null;

function report(pathname: string): void {
  if (window.parent === window) return;
  window.parent.postMessage({ type: 'design-constructor-route', pathname }, '*');
}

/** The route the Design Constructor has for this page: what an overlay such as the reveal reports again when it closes. */
export function currentRoute(): string {
  return pageRoute ?? window.location.pathname;
}

/**
 * Tells the Design Constructor preview which page this is when its route is not in the URL (the custom pack lab
 * is served at `/`, like the pack page), so the sidebar lists that page's components. A page outside the preview
 * says nothing.
 */
export function useReportPageRoute(pathname: string | null): void {
  useEffect(() => {
    if (pathname === null || !isChildMode()) return;
    pageRoute = pathname;
    const send = () => report(pathname);
    send();
    // The preview reads the real path of the iframe once its document has loaded, which can come after the
    // message above (a page that renders at once): say it again then.
    if (document.readyState !== 'complete') window.addEventListener('load', send, { once: true });
    return () => {
      window.removeEventListener('load', send);
      pageRoute = null;
      report(window.location.pathname);
    };
  }, [pathname]);
}
